import { IList } from "../../../../utils/generalType";
import ServiceCyberSecurityCard from "./Service_Cyber";
import { ServiceExecutiveBrandingCard } from "./Service_Executives_Branding";
import ServiceInfluencerMarketingCard from "./Service_Influencer_Marketing";
import ServiceMobileAppCard from "./Service_Mobile";
import ServiceORMCard from "./Service_ORM";
import ServicePRCard from "./Service_PR";
import ServiceSEOCard from "./Service_SEO";
import ServiceSMACard from "./Service_SMA";
import ServiceSocialFootPrintCard from "./Service_Social_Foot_Print";
import ServiceTwitterTrendCard from "./Service_Twitter_Trend";
import ServiceWebDesignCard from "./Service_Web";

export const services: IList[] = [
  {
    title: "Public Relations",
    subTitle: "Elevate Your Brand with Reputation & Brand Boosting",
    caption:
      "Beyond digital, Clearwater extends its expertise into crafting press releases, media outreach, crisis communication, and brand storytelling. This holistic approach ensures a consistent and positive brand image across all channels, both online and offline.",
    image: `${process.env.PUBLIC_URL + "/images/services/service_market.jpg"}`,
    content: <ServicePRCard />,
    link: "/landing/services/1/Public_Relations_Management",
  },
  {
    title: "Online Reputation Management (ORM)",
    subTitle: "Safeguard and Enhance Your Digital Presence",
    caption:
      "Our Online Reputation Management service offers discreet and rapid solutions to safeguard your digital presence. We specialize in the strategic deletions and removals of unwanted content, ensuring your online image remains pristine and corporate.",
    image: `${process.env.PUBLIC_URL + "/images/services/orm.jpg"}`,
    content: <ServiceORMCard />,
    link: "/landing/services/2/Online_Reputation_Management",
  },
  {
    title: "Search Engine Optimization",
    subTitle: "Boost Your Online Presence with Advanced SEO Techniques",
    caption:
      " Clearwater excels in driving organic traffic through strategic SEO practices. They employ both on-page and off-page optimization techniques to ensure clients rank highly on search engine results pages.",
    image: `${
      process.env.PUBLIC_URL + "/images/services/service_strategy.jpg"
    }`,
    content: <ServiceSEOCard />,
    link: "/landing/services/3/SEO",
  },
  {
    title: "Social Media Advocacy",
    subTitle: "Harness the Power of Social Media to Amplify Your Brand",
    caption:
      "Leveraging the power of social platforms, Clearwater Communications crafts bespoke social media strategies that boost brand visibility, engage with audiences, and drive conversions. Their approach is data-driven, ensuring campaigns resonate with the target demographic.",
    image: `${
      process.env.PUBLIC_URL +
      "/images/services/service_Social_media_advocacy.jpg"
    }`,
    content: <ServiceSMACard />,
    link: "/landing/services/4/social_Media_Advocacy",
  },
  {
    title: "Adaptive Web Design",
    subTitle: "Transforming Your Vision into a Stunning Online Presence",
    caption:
      "Crafting responsive, user-friendly websites that are not only aesthetically pleasing but also optimized for performance and SEO. Clearwater Communications ensures that each site is built with scalability in mind, allowing businesses to grow their online presence effortlessly.",
    image: `${process.env.PUBLIC_URL + "/images/services/service_web.jpg"}`,
    content: <ServiceWebDesignCard />,
    link: "/landing/services/5/Website_Design",
  },
  {
    title: "Mobile Apps Development",
    subTitle: "Transforming Ideas into Intuitive, High-Performance Mobile Apps",
    caption:
      "Specializing in developing mobile apps for both Android and iOS platforms, Clearwater Communications delivers applications that enhance user engagement, offer seamless functionality, and provide an intuitive user interface. Their apps are designed to meet the high standards of app stores, focusing on user retention and satisfaction.",
    image: `${process.env.PUBLIC_URL + "/images/services/service_mobile.jpg"}`,
    content: <ServiceMobileAppCard />,
    link: "/landing/services/6/MobileApp_Development",
  },
  {
    title: "Cyber Security",
    subTitle: "Protect Your Business with Advanced Cyber Security Solutions",
    caption:
      "Safeguard your business with cutting-edge cyber security strategies tailored to your needs. Let’s protect your data and assets.",
    image: `${
      process.env.PUBLIC_URL + "/images/services/service_cyber_security.jpg"
    }`,
    content: <ServiceCyberSecurityCard />,
    link: "/landing/services/7/Cyber_Security",
  },
  {
    title: "Social Media Footprint Expansion",
    subTitle: "Broaden Your Online Reach with Strategic Social Media Growth",
    caption:
      "Expand your digital footprint and connect with new audiences through targeted social media growth strategies.",
    image: `${
      process.env.PUBLIC_URL +
      "/images/services/service_social_media_expansion.jpg"
    }`,
    content: <ServiceSocialFootPrintCard />,
    link: "/landing/services/8/Social_Media_Foot_Print_Expansion",
  },
  {
    title: "Twitter Trend Takeover",
    subTitle:
      "Dominate the Twitter Conversation with Our Trend Takeover Service",
    caption:
      "Create buzz on Twitter and become a top trend with our specialized trend takeover service. Let’s get you trending!",
    image: `${
      process.env.PUBLIC_URL + "/images/services/service_twitter_trend.jpg"
    }`,
    content: <ServiceTwitterTrendCard />,
    link: "/landing/services/9/Twitter_Trend_Take_Over",
  },
  {
    title: "Influencer Marketing",
    subTitle: "Leverage Influencers to Amplify Your Brand's Reach",
    caption:
      "Harnessing the power of influencers, Clearwater connects brands with personalities that align with their values and target market. This service includes strategy development, influencer selection, campaign execution, and performance analysis to amplify brand messages through trusted voices.",
    image: `${
      process.env.PUBLIC_URL +
      "/images/services/service_influencer_marketing.jpg"
    }`,
    content: <ServiceInfluencerMarketingCard />,
    link: "/landing/services/10/Influencer_Marketing",
  },
  {
    title: "Executive Branding",
    subTitle:
      "Build a Powerful Personal Brand with Our Executive Branding Service",
    caption:
      "Strengthen your personal brand and enhance your leadership profile with strategic executive branding services.",
    image: `${
      process.env.PUBLIC_URL + "/images/services/service_executive_branding.jpg"
    }`,
    content: <ServiceExecutiveBrandingCard />,
    link: "/landing/services/11/Executives_Branding",
  },
];

export const jobs: IList[] = [
  {
    title: "Linkmie",
    subTitle: "Linkmie",
    caption:
      "Linkmie is a dynamic P2P advertisement platform designed to connect publishers and advertisers seamlessly.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/1.png"}`,
    content: (
      <>
        <p>
          Linkmie is a results-oriented platform facilitating peer-to-peer
          advertising for brands and influencers. We developed a scalable,
          SEO-optimized web app using cutting-edge technologies.
        </p>
        <p>
          We prioritized smooth user onboarding, secure payment gateway
          integration, and a mobile-responsive UI to effectively support
          advertisers and publishers.
        </p>
        <p>
          The platform includes advanced analytics, ad campaign management
          tools, and real-time tracking to ensure high engagement and
          transparency.
        </p>
        <p>
          Our team handled everything from branding to backend development,
          delivering an innovative solution for monetizing digital traffic
          effortlessly.
        </p>
      </>
    ),
    link: "https://linkmie.com",
    tag: ["Web", "Agency", "SEO"],
    category: "Web_Development",
  },
  {
    title: "Idashyou",
    subTitle: "Idashyou.ng",
    caption:
      "iDashyou is a compassionate crowdfunding platform designed to empower individuals and communities to raise funds for causes that matter.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/2.png"}`,
    content: (
      <>
        <p>
          iDashyou was created to facilitate humanitarian efforts, personal
          projects, and emergencies with user-friendly fundraising tools.
        </p>
        <p>
          It features secure donation processes, wallet management, and donor
          notifications, enhanced by effective SEO strategies and a streamlined
          UX.
        </p>
        <p>
          We incorporated flexible payment options and a real-time dashboard for
          monitoring campaigns and engaging donors.
        </p>
        <p>
          This responsive web platform fosters emotional connections with
          causes, simplifying the entire donation experience.
        </p>
      </>
    ),
    link: "https://idashyou.com/",
    tag: ["web", "SEO", "Donation", "Payment Gateway"],
    category: "Web_Development",
  },
  {
    title: "Jamb CBT Learning App",
    subTitle: "Jamb CBT Learning App",
    caption:
      "Master Your Exams with Ease – Jamb CBT Learning App: Your Ultimate Study Companion!",
    image: `${process.env.PUBLIC_URL + "/images/jobs/3.png"}`,
    content: (
      <>
        <p>
          Tailored for JAMB exam preparation, this app replicates real exam
          scenarios to improve student readiness.
        </p>
        <p>
          We emphasized a user-friendly UI/UX, organized subject categories,
          result tracking, and detailed progress analytics for an engaging
          learning experience.
        </p>
        <p>
          Features like offline access, instant feedback, and leaderboard
          gamification were added to enhance motivation and knowledge retention.
        </p>
        <p>
          We also integrated payment gateways for premium features and optimized
          SEO for better visibility on app stores.
        </p>
      </>
    ),
    link: "https://play.google.com/store/apps/details?id=com.lfxedu.jambproject",
    tag: ["App", "SEO", "E-learning", "Payment Gateway"],
    category: "App_Development",
  },
  {
    title: "LampHills Website",
    subTitle: "LampHills Website",
    caption:
      "LampHills: Your Trusted Partner for Strategic PR Solutions – Elevate Your Brand, Amplify Your Voice",
    image: `${process.env.PUBLIC_URL + "/images/jobs/4.png"}`,
    content: (
      <>
        <p>
          LampHills provides PR and communication services, focusing on
          compelling brand storytelling and strategic exposure.
        </p>
        <p>
          We crafted a visually striking website with a robust editorial layout
          and full mobile responsiveness for PR experts.
        </p>
        <p>
          Our team implemented a content management system, lead generation
          forms, and adhered to SEO best practices.
        </p>
        <p>
          This project significantly boosted their online visibility and client
          acquisition through strategic design and development.
        </p>
      </>
    ),
    link: "https://lamphills.com/",
    tag: ["web", "SEO", "Agency", "Payment Gateway"],
    category: "Web_Development",
  },
  {
    title: "Edu learn App",
    subTitle: "Edu Learn App",
    caption:
      "Edu Learn App: Empowering K-12 Students with Engaging and Effective Learning Tools!",
    image: `${process.env.PUBLIC_URL + "/images/jobs/5.png"}`,
    content: (
      <>
        <p>
          Edu Learn App delivers curriculum-aligned resources, quizzes, and
          progress tracking for K-12 students.
        </p>
        <p>
          It includes gamified learning experiences, video lessons, parental
          oversight tools, and personalized learning paths.
        </p>
        <p>
          We ensured cross-device compatibility and app store optimization using
          modern frameworks and a modular design approach.
        </p>
        <p>
          Our responsibilities covered UX design, user testing, deployment, and
          ongoing support.
        </p>
      </>
    ),
    link: "https://apps.apple.com/gb/app/edu-learn-app/id6670703012?uo=2",
    tag: ["App", "SEO", "E-learning", "Payment Gateway"],
    category: "App_Development",
  },
  {
    title: "Soft Life App",
    subTitle: "Soft Life App",
    caption:
      "Discover the ultimate hair care experience with the Soft Life App. Book appointments, explore styles, and manage your hair wellness effortlessly.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/6.png"}`,
    content: (
      <>
        <p>
          Soft Life App links users with hair stylists, services, and wellness
          providers via a sleek booking interface.
        </p>
        <p>
          We developed a comprehensive booking system, wallet functionality,
          vendor dashboards, and style galleries to improve user experience.
        </p>
        <p>
          The app focuses on usability, with custom admin controls for managing
          services and vendor onboarding seamlessly.
        </p>
        <p>
          This app combines beauty and functionality, merging wellness with
          ecommerce in a seamless way.
        </p>
      </>
    ),
    link: "https://softlifeng.com/",
    tag: ["Web", "SEO", "Beauty", "Skin Care", "Payment Gateway"],
    category: "Web_Development",
  },
  {
    title: "Herald",
    subTitle: "Herald Website",
    caption:
      "Nigeria's number one trusted news website on politics, sports, lifestyle, entertainment, and information.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/8.png"}`,
    content: (
      <>
        <p>
          We revamped Herald's digital presence to be more streamlined, faster,
          and mobile-optimized for efficient news delivery.
        </p>
        <p>
          The CMS-based platform supports high-traffic news updates and breaking
          stories with enhanced performance and SEO structure.
        </p>
        <p>
          Our tasks included redesigning the layout, optimizing ads, and
          integrating social media functionalities.
        </p>
        <p>
          It’s now a leading news portal for Nigerians globally, designed to
          scale and inform effectively.
        </p>
      </>
    ),
    link: "https://herald.ng/",
    tag: ["Web", "SEO", "Agency", "News", "WordPress"],
    category: "Web_Development",
  },
  {
    title: "Business Yield",
    subTitle: "Business Yield Website",
    caption:
      "Business Yield delivers insights, news, and guides for entrepreneurs and startups.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/10.png"}`,
    content: (
      <>
        <p>
          For Business Yield, we created a fast, SEO-optimized WordPress site
          dedicated to financial education and entrepreneurship.
        </p>
        <p>
          We tailored multiple content formats, set up newsletter automation,
          and optimized for ad revenue generation.
        </p>
        <p>
          The project demanded a responsive UI, accessible content, and
          consistent branding.
        </p>
        <p>
          Business Yield has since become a go-to resource for finance and
          business readers, steadily growing its audience.
        </p>
      </>
    ),
    link: "https://businessyieldconsult.com/",
    tag: ["Web", "SEO", "Agency", "News", "WordPress"],
    category: "Web_Development",
  },
  {
    title: "Zenith Bank",
    subTitle: "Zenith",
    caption:
      "Managed and enhanced social media presence, increasing brand engagement for Zenith Bank.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/9.png"}`,
    content: (
      <>
        <p>
          We enhanced Zenith Bank’s digital marketing approach, focusing on
          social media platforms.
        </p>
        <p>
          Our efforts included creating visual content, setting up analytics,
          and developing engagement strategies across Twitter, Instagram, and
          LinkedIn.
        </p>
        <p>
          Through consistent branding and targeted messaging, we achieved
          increased follower growth and improved click-through rates.
        </p>
        <p>
          This project showcased our expertise in blending marketing strategy
          with creative design and data-driven reporting.
        </p>
      </>
    ),
    link: "http://zenithbank.com/",
    tag: ["Web", "SEO", "Agency", "News", "WordPress"],
    category: "Social_Media",
  },
  {
    title: "New Era School Portal",
    subTitle: "New Era",
    caption:
      "A centralized portal for student management, academic results, payments, and parent communication.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/11.png"}`,
    content: (
      <>
        <p>
          This portal was developed to streamline academic operations for New
          Era schools, minimizing paperwork and enhancing communication.
        </p>
        <p>
          We incorporated features like student registration, payment
          processing, and result tracking into a secure online dashboard.
        </p>
        <p>
          It also offers parent messaging, class schedules, and attendance
          tracking functionalities.
        </p>
        <p>
          We ensured mobile responsiveness and a teacher-friendly interface
          during implementation.
        </p>
      </>
    ),
    link: "http://neweramodelschools.com/",
    tag: ["Web", "SEO", "Agency", "News", "WordPress", "School Portal"],
    category: "Web_Development",
  },
  {
    title: "Inventory Software",
    subTitle: "Inventory Software",
    caption:
      "A full-featured inventory and accounting solution for small and medium businesses.",
    image: `${process.env.PUBLIC_URL + "/images/jobs/7.png"}`,
    content: (
      <>
        <p>
          We designed this inventory management tool to streamline stock
          control, sales tracking, and financial reporting for businesses.
        </p>
        <p>
          It includes barcode integration, purchase order management, tax
          configurations, and accounting features.
        </p>
        <p>
          We built user roles and data analytics dashboards to help admins
          manage operations effectively.
        </p>
        <p>
          This tool was customized to address the daily needs of shops,
          warehouses, and service-based businesses.
        </p>
      </>
    ),
    link: "https://fola-ogunde-portfolio.vercel.app/product/inventory_Software",
    tag: [
      "Web",
      "SEO",
      "Agency",
      "News",
      "WordPress",
      "Software Development",
      "Accounting",
    ],
    category: "Web_Development",
  },
];

export const servicesPortfolio: IList[] = [
  {
    title: "Web Development",
    desc: "I create swift, contemporary, and fully operational websites aligned with your business objectives.",
    icon: "🌐",
  },
  {
    title: "App Development",
    desc: "From ideation to release, I develop intuitive mobile and web apps that drive impactful results.",
    icon: "📱",
  },
  {
    title: "Photography",
    desc: "Expert photography that reflects your brand’s core and captivates your target audience.",
    icon: "📷",
  },
  {
    title: "SEO Marketing",
    desc: "Boost your online presence and climb search engine rankings with proven SEO techniques.",
    icon: "🔍",
  },
  {
    title: "Responsive Design",
    desc: "Designs that seamlessly adapt across devices, delivering a consistent and smooth user experience.",
    icon: "🖥️",
  },
  {
    title: "Digital Marketing",
    desc: "Targeted digital campaigns to help your brand engage, expand, and convert effectively online.",
    icon: "💻",
  },
];

export const serviceWorkflow: IList[] = [
  {
    title: "Discuss the project",
    image: `${process.env.PUBLIC_URL}/images/site/blog3.jpg`,
  },
  {
    title: "Develop & elaborate",
    image: `${process.env.PUBLIC_URL}/images/site/blog4.jpg`,
  },
  {
    title: "Final approval",
    image: `${process.env.PUBLIC_URL}/images/site/blog6.jpg`,
  },
];

// *********** Inventory       ***********  //

export const inventoryFeatures: IList[] = [
  {
    title: "Real-Time Tracking",
    desc: "Monitor stock levels and inventory movement instantly for better decision-making.",
    icon: "⏱️",
  },
  {
    title: "Stock Alerts",
    desc: "Get notified when stock is low or out to avoid shortages and maintain supply levels.",
    icon: "🚨",
  },
  {
    title: "Multi-Warehouse Support",
    desc: "Manage inventory across multiple warehouses with centralized visibility and control.",
    icon: "🏬",
  },
  {
    title: "Sales Management",
    desc: "Track sales orders, invoices, and customer transactions efficiently in one place.",
    icon: "💰",
  },
  {
    title: "Purchase Management",
    desc: "Handle vendor purchases, purchase orders, and stock receipts with ease.",
    icon: "🛒",
  },
  {
    title: "Expenses Tracker",
    desc: "Record and monitor business expenses to keep track of operational costs.",
    icon: "📉",
  },
  {
    title: "Income Tracker",
    desc: "Log income from various sources to maintain a clear view of profitability.",
    icon: "📈",
  },
  {
    title: "Account Management",
    desc: "Manage financial accounts, balances, and transactions within your inventory system.",
    icon: "🧾",
  },
  {
    title: "Adjustment Management",
    desc: "Handle inventory discrepancies and stock adjustments accurately and efficiently.",
    icon: "⚙️",
  },
];
